// extracted by mini-css-extract-plugin
export default {"name_page":"FormPhone_name_page__JtyVl","bio":"FormPhone_bio__QqHdn","item_input":"FormPhone_item_input__QkO14","btn_login":"FormPhone_btn_login__CdHZE","err":"FormPhone_err__PkLHh"};